import {
    SET_ASSET_ASSOCIATIONS,
    SET_ASSET_ASSOCIATIONS_METADATA,
    SET_ASSET_ASSOCIATIONS_RECORD,
    SET_ASSET_ASSOCIATIONS_LOADING
} from "../types";
import axios from "axios";
import { handleResponse } from "./response";
import { handleError } from "./error";

// TODO: New version of this file.
//  Don't pass associations with first request
//  Now, any time a property is saved, it attempts to update that properts associations based on the propert association data
//  Instead, Associations should be able to act independently. Pull their data separately from the model

export const fetchAssetAssociations = (module, module_id) => async (dispatch) => {
    try {
        dispatch(setAssetAssociationsLoading(true));
        let response = await axios.get(`/associations/${module}/${module_id}/`);
        dispatch(setAssetAssociationsLoading(false));
        dispatch(setAssetAssociations(response.data.asset_associations));
        dispatch(setMetadata(response.data));
        dispatch(setRecord({
            module: module,
            id: module_id
        }));
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

/**
 * @name setAssetAssociations
 */
export const setAssetAssociations = (associations) => async (dispatch) => {
    try {
        dispatch({
            type: SET_ASSET_ASSOCIATIONS,
            payload: associations
        });
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

export const setMetadata = (metadata) => async (dispatch) => {
    try {
        dispatch({
            type: SET_ASSET_ASSOCIATIONS_METADATA,
            payload: metadata
        });
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

export const setRecord = (record) => async (dispatch) => {
    try {
        dispatch({
            type: SET_ASSET_ASSOCIATIONS_RECORD,
            payload: record
        });
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

/**
 * @name    updateAssociations
 * @param   event
 * @returns {function(...[*]=)}
 */
export const updateAssociations = event => async (dispatch, getState) => {
    try {
        //  DESC:TITLE - TITLE CLEARED
        const { name, value } = event.target;
        const { assetAssociations: { metadata, record } } = getState();

        let postData = { reactAPI: true };
        let association = JSON.parse(value);
        let postUrl = event.target.action === "delete" ?
            "/associations/" + record.module + '/' + record.id + "/delete" :
            "/associations/" + record.module + '/' + record.id;

        // eslint-disable-next-line no-unused-vars
        for (const [field_key, field] of Object.entries(association)) {
            postData[field_key] = field;
        }

        dispatch(setAssetAssociationsLoading(true));
        const response = await axios.post(postUrl, postData);
        dispatch(setAssetAssociationsLoading(false));

        await dispatch(handleResponse(response));

        dispatch({
            type: SET_ASSET_ASSOCIATIONS,
            payload: response.data.asset_associations
        });
        metadata.extended_associations = response.data.extended_associations;
        metadata.asset_associations = response.data.asset_associations;
        metadata.all_relationships_associations = response.data.all_relationships_associations;
        await dispatch({
            type: SET_ASSET_ASSOCIATIONS_METADATA,
            payload: { ...metadata }
        });
        if (event.target.action === "delete") {
            document
                .querySelector(`#log_row_confirm_modal_close_btn_${name}`)
                .click();
        }
        else {
            document.querySelector(`#log_row_modal_close_btn_${name}`).click();
        }
        // reload existing graph
        let relationship_code = document
            .querySelector("#generate_graph_btn")
            .getAttribute("data-code");
        if (relationship_code !== "") {
            await dispatch(ShowNetworkGraph(relationship_code));
        }
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

/**
 * @name    onDeleteGraph
 * @param   event
 * @returns {function(...[*]=)}
 */
export const onDeleteGraph = event => async (dispatch, getState) => {
    try {
        //  DESC:TITLE - TITLE CLEARED
        const { name } = event.target;
        const {
            assetAssociations: {
                metadata,
                record
            }
        } = getState();

        //  DESC:Pre-defined an empty Error
        // console.log("onDeleteGraph");
        // console.log(event);
        let id = parseInt(
            document
                .getElementById(
                    "log_row_confirm_modal_graph_submit_btn_asset_associations"
                )
                .getAttribute("data-id")
        );

        let code = document
            .getElementById(
                "log_row_confirm_modal_graph_submit_btn_asset_associations"
            )
            .getAttribute("data-code");

        let node_id = document
            .getElementById(
                "log_row_confirm_modal_graph_submit_btn_asset_associations"
            )
            .getAttribute("data-property");

        let action = document
            .getElementById(
                "log_row_confirm_modal_graph_submit_btn_asset_associations"
            )
            .getAttribute("data-action");

        let data = {};

        metadata.asset_associations.map(extended => {
            if (extended.id === id) {
                data = extended;
            }
        });

        let relationship_array = data.relationship.split(",");

        const index = relationship_array.indexOf(code);
        if (index > -1) {
            relationship_array.splice(index, 1);
        }
        data.relationship = relationship_array.toString();

        let postData = { reactAPI: true, node_id: node_id };

        let postUrl = action === "delete" ?
            "/associations/" + record.module + '/' + record.id + "/delete" :
            "/associations/" + record.module + '/' + record.id;

        // eslint-disable-next-line no-unused-vars
        for (const [field_key, field] of Object.entries(data)) {
            postData[field_key] = field;
        }

        const response = await axios.post(postUrl, postData);

        await dispatch(handleResponse(response));
        dispatch({
            type: SET_ASSET_ASSOCIATIONS,
            payload: response.data.asset_associations
        });
        metadata.extended_associations = response.data.extended_associations;
        metadata.all_relationships_associations = response.data.all_relationships_associations;

        await dispatch({
            type: SET_ASSET_ASSOCIATIONS_METADATA,
            payload: { ...metadata }
        });

        document
            .querySelector(`#log_row_confirm_modal_graph_close_btn_${name}`)
            .click();
        // reload existing graph
        let relationship_code = document
            .querySelector("#generate_graph_btn")
            .getAttribute("data-code");
        if (relationship_code !== "") {
            await dispatch(ShowNetworkGraph(relationship_code));
        }
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

/**
 * @name    setAssetAssociations
 */
export const ShowNetworkGraph = relationship_code => async (
    dispatch,
    getState
) => {
    try {
        const { assetAssociations: { metadata, record } } = getState();

        document
            .querySelector("#generate_graph_btn")
            .setAttribute("data-code", relationship_code);

        let postUrl = `/associations/${record.module}/${record.id}/graph`;
        let postData = { reactAPI: true, relationship_code: relationship_code };
        const response = await axios.post(postUrl, postData);

        await dispatch(handleResponse(response));
        metadata.network_graph = response.data;
        await dispatch({
            type: SET_ASSET_ASSOCIATIONS_METADATA,
            payload: { ...metadata }
        });
        if (response.data.hasOwnProperty("graph_data")) {
            if (!response.data.graph_data.length) {
                document.querySelector("#network_result_message").innerHTML =
                    "There is no associations with selected relationship.";
                document.querySelector(
                    "#network_result_message"
                ).style.display = "block";
            }
            else {
                document.querySelector(
                    "#network_result_message"
                ).style.display = "none";
            }
        }
        else {
            document.querySelector("#network_result_message").innerHTML =
                "Graph is limited to certain connections amount.";
            document.querySelector("#network_result_message").style.display =
                "block";
        }
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

/**
 * @name    setAssetAssociationsLoading
 */
export const setAssetAssociationsLoading = payload => async (
    dispatch,
    getState
) => {
    try {
        await dispatch({
            type: SET_ASSET_ASSOCIATIONS_LOADING,
            payload,       
        });
    } catch(error) {
        dispatch(handleError(error));
    }
};